import Home from "./components/home/Home.vue";
import Login from "./components/login/Login.vue";
import Logout from "./components/logout/Logout.vue";
import ChoiceTemplate from "./components/choice_template/ChoiceTemplate.vue";
import ChoiceProducts from "./components/choice_products/ChoiceProducts.vue";
import ChoiceOptions from "./components/choice_options/ChoiceOptions.vue";
import CircularList from "./components/circular_list/CircularList.vue";
import Generate2x from "./components/generate2x/Generate2x.vue";
import Generate3x from "./components/generate3x/Generate3x.vue";
import Generate4x from "./components/generate4x/Generate4x.vue";
import Generate5x from "./components/generate5x/Generate5x.vue";
import Generate6x from "./components/generate6x/Generate6x.vue";
import Generate7x from "./components/generate7x/Generate7x.vue";
import Generate8x from "./components/generate8x/Generate8x.vue";
import Generate9x from "./components/generate9x/Generate9x.vue";

export const routes = [
  {
    path: "",
    component: ChoiceTemplate
  },
  {
    path: "/login",
    component: Login
  },
  {
    path: "/logout",
    component: Logout
  },
  {
    path: "/nova-circular",
    component: ChoiceTemplate
  },
  {
    path: "/escolher-produtos/:id_template",
    component: ChoiceProducts
  },
  {
    name: "opcoes_circular",
    path: "/opcoes-circular",
    component: ChoiceOptions
  },
  {
    path: "/gerar",
    component: CircularList
  },
  {
    name: "gera_circular_2x",
    path: "/gerar-circular-2",
    component: Generate2x
  },
  {
    name: "gera_circular_3x",
    path: "/gerar-circular-3",
    component: Generate3x
  },
  {
    name: "gera_circular_4x",
    path: "/gerar-circular-4",
    component: Generate4x
  },
  {
    name: "gera_circular_5x",
    path: "/gerar-circular-5",
    component: Generate5x
  },
  {
    name: "gera_circular_6x",
    path: "/gerar-circular-6",
    component: Generate6x
  },
  {
    name: "gera_circular_7x",
    path: "/gerar-circular-7",
    component: Generate7x
  },
  {
    name: "gera_circular_8x",
    path: "/gerar-circular-8",
    component: Generate8x
  },
  {
    name: "gera_circular_9x",
    path: "/gerar-circular-9",
    component: Generate9x
  }
];



// WEBPACK FOOTER //
// ./src/routes.js